/**
 * Indicates that a service has not been initialized yet.
 *
 * _Note: This value is for internal use only._
 */
export const EMPTY_VALUE = Symbol('EMPTY_VALUE');
//# sourceMappingURL=empty.const.mjs.map